import savingActionTypes from '../../constants/saving-action-types';

const updateSiteProperty = (name, value) => ({
  type: savingActionTypes.SET_SITE_PROPERTY,
  name,
  value,
});

export default updateSiteProperty;
